import { AsyncPipe } from '@angular/common';
import { Component } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { RootState } from '@next/core-lib/app';
import { PageDetailComponent } from '@next/core-lib/components';
import { LocaleService } from '@next/core-lib/i18n';
import { RouterSelectors } from '@next/core-lib/router-store';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AnimalGroupNavigationComponent } from '../animal-group-navigation/animal-group-navigation.component';

@Component({
  selector: 'app-animal-group-item',
  templateUrl: './animal-group-item.component.html',
  imports: [PageDetailComponent, AnimalGroupNavigationComponent, RouterOutlet, AsyncPipe],
})
export class AnimalGroupItemComponent {
  pageTitle$: Observable<string> = this.store.pipe(
    select(RouterSelectors.getPath),
    map((routeUrl) =>
      this.locale.translate(
        `animal-group.${routeUrl.endsWith('/animal-group/add') ? 'add' : 'edit'}-animal-group`,
      ),
    ),
  );

  constructor(
    private readonly store: Store<RootState>,
    private readonly locale: LocaleService,
    private readonly router: Router,
  ) {}

  back = () => this.router.navigate(['/animal-group']);
}
